module.exports = __webpack_public_path__ + "static/flags/MR-9fb6cf25549b3772482d059c0282f56a.gif";